import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { HomePage } from './features/home/HomePage';
import { WeddingsPage } from './features/weddings/WeddingsPage';
import { GalleryPage } from './features/gallery/GalleryPage';
import { AboutPage } from './features/about/AboutPage';
import { BabyPhotographyPage } from './features/baby-photography/BabyPhotographyPage';
import { DestinationWeddingsPage } from './features/destination-weddings/DestinationWeddingsPage';
import { Loading } from './components/common/Loading';

// Heavier routes are split out: the booking form (react-hook-form + zod) and admin (Apollo/GraphQL).
const ContactPage = lazy(() => import('./features/contact/ContactPage').then((m) => ({ default: m.ContactPage })));
const AdminRoutes = lazy(() => import('./features/auth/AdminRoutes'));

function AppRoutes() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/weddings" element={<WeddingsPage />} />
        <Route path="/baby-photography" element={<BabyPhotographyPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/destination-weddings" element={<DestinationWeddingsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/admin/*" element={<AdminRoutes />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
